import { dbFS, dbFB, functions } from "@/components/firebase.js";
let unsuscribeUser,
  unsuscribeInmuebles,
  unsuscribeCoPropietarios,
  unsuscribeFirmas;
const discapacidadModel = {
  isDiscapacidad: false,
  tipo: false,
  grado: 0,
  movilidad: false,
  documentoDiscapacidad: false
};
const modelUser = {
  apellido1: "",
  apellido2: "",
  nombre: "",
  nif: "",
  tlf: [],
  tlf1: "",
  sexo: 0,
  fechaNacimientoDia: null,
  fechaNacimientoMes: null,
  fechaNacimientoYear: null,
  direccion: {},
  discapacidad: discapacidadModel,
  inmueblesList: []
};
/* const modelCoPropietario = {
  dataUser: modelUser,
  cuota: 0,
  discapacidad: false,
  empadronado: false,
  mayor65: false,
  padronStatusConocido: 0,
  tipo: false,
  volante: false
}; */
const dataInmueble = {
  cuota: 0,
  discapacidad: false,
  empadronado: false,
  mayor65: false,
  padronStatusConocido: 0,
  tipo: false,
  volante: false
};
const modelCoPropietario = {
  dataUser: modelUser,
  dataInmueble: dataInmueble
};
const inmuebleModel = {
  customId: "",
  direccion: {},
  expte: "",
  inmuebleData: {
    cuota: "",
    direccion: "",
    escalera: "",
    letra: "",
    participa: true,
    piso: "",
    refCat: "",
    superficie: "",
    uso: "",
    year: ""
  },
  listInmuebles: [],
  refInmueble: {
    nonce: "",
    num: "",
    refCat: ""
  }
};
export default {
  state: {
    iprem: 7520,
    propietario: null,
    coPropietarios: null,
    inmuebles: null,
    inmueblesDisponibles: null,
    ultimoCoProAgregado: null,
    changeInmuebles: false,
    // inmueblesPropietario: [],
    dialogs: {
      formProfile: false,
      formInmueble: false,
      formProfileInmueble: false
    },
    savedFirma: false,
    firmas: null
  },
  getters: {
    firmas: state => {
      return state.firmas;
    },
    savedFirma: state => {
      return state.savedFirma;
    },
    inmueblesDisponibles: state => {
      return state.inmueblesDisponibles ? state.inmueblesDisponibles : [];
    },
    iprem: state => {
      return state.iprem;
    },
    allUsers: state => {
      if (!state.propietario) {
        return [];
      }
      /* let inmus = [];
      if (state.inmuebles) {
        inmus = state.inmuebles.map(i => {
          return {
            users: i.users,
            refCat: i.inmuebleData.refCat
          };
        });
      } */
      let result = [state.propietario];
      if (state.coPropietarios) {
        state.coPropietarios.forEach(prop => {
          let data = prop.dataUser;
          data.id = prop.id;
          result.push(data);
        });
      }
      return result;
    },
    ultimoCoProAgregado: state => {
      return state.ultimoCoProAgregado;
    },
    changeInmuebles: state => {
      return state.changeInmuebles;
    },
    propietario: state => {
      return state.propietario;
    },
    coPropietarios: state => {
      return state.coPropietarios;
    },
    discapacidad: state => {
      if (state.propietario) {
        return state.propietario.discapacidad;
      }
      return discapacidadModel;
    },
    inmueblesPropietario: state => {
      return state.inmuebles;
      /* const result =
        state.propietario && state.propietario.inmueblesList
          ? state.propietario.inmueblesList
          : [];
      return result; */
      // return state.inmueblesPropietario;
      /* if (!state.propietario || !state.propietario.inmuebles) {
        return [];
      }
      const items = state.propietario.inmuebles;
      let result = items;
      if (!Array.isArray(items)) {
        result = Object.keys(items);
      }
      return result; */
    },
    dialogUsuario: state => {
      return state.dialogs.formProfile;
    },
    dialogInmueble: state => {
      return state.dialogs.formInmueble;
    },
    dialogUsuarioInmueble: state => {
      return state.dialogs.formProfileInmueble;
    },
    propietarioModel: () => {
      return modelUser;
    },
    propietarioInmuebleModel: () => {
      return inmuebleModel;
    },
    fechaNac: () => {
      let result = {
        dias: [],
        meses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        years: []
      };
      const actualYear = new Date().getFullYear();
      const rango = 120;
      for (let index = actualYear; index > actualYear - rango; index--) {
        result.years.push(index);
      }
      for (let index = 1; index < 32; index++) {
        result.dias.push(index);
      }
      return result;
    }
  },
  mutations: {
    setUltimoCoProAgregado: (state, payload) => {
      state.ultimoCoProAgregado = payload;
    },
    setPropietario: (state, payload) => {
      state.propietario = payload;
    },
    setInmueblesPropietario: (state, payload) => {
      if (!state.propietario.inmueblesList) {
        state.propietario.inmueblesList = [payload];
      } else {
        state.propietario.inmueblesList.push(payload);
      }
      state.changeInmuebles = true;
      /* if (
        !state.propietario.inmueblesList ||
        state.propietario.inmueblesList.filter(i => i.expte === payload.expte)
          .length < 1
      ) {
        state.propietario.inmueblesList.push(payload);
      } */
      /* if (
        state.inmueblesPropietario.filter(i => i.expte === payload.expte)
          .length < 1
      ) {
        state.inmueblesPropietario.push(payload);
      } */
    },
    setChangeInmuebles: (state, payload) => {
      state.changeInmuebles = payload;
    },
    setDialogUsuario: (state, payload) => {
      state.dialogs.formProfile = payload;
    },
    setDialogInmueble: (state, payload) => {
      state.dialogs.formInmueble = payload;
    },
    setDialogProfileInmueble: (state, payload) => {
      state.dialogs.formProfileInmueble = payload;
    },
    setFirmasMut: (state, payload) => {
      state.firmas = payload;
    },
    setCoPropietarios: (state, payload) => {
      state.coPropietarios = payload;
    },
    setDataInmuebles: (state, payload) => {
      state.inmuebles = payload;
    },
    setInmueblesDisponibles: (state, payload) => {
      state.inmueblesDisponibles = payload;
    },
    firmaGuardada: (state, payload) => {
      state.savedFirma = payload;
    }
  },
  actions: {
    deleteInmueble: ({ rootState, state, dispatch }, payload) => {
      const uid = rootState.user.uid;
      let inmueblesProp = state.propietario.inmuebles
        ? state.propietario.inmuebles
        : [];
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("data-inmuebles")
        .doc(`${payload}`)
        .delete()
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Inmueble eliminado", payload);
          let result = [];
          inmueblesProp.forEach(item => {
            if (item != payload) {
              result.push(item);
            }
          });
          dispatch("updateInmuebleUser", result);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error("Error eliminado Inmueble: ", error);
        });
    },
    setNuevoInmueble: ({ rootState, state, dispatch }, payload) => {
      // Agrega un nuevo inmueble al propietario
      const uid = rootState.user.uid;
      const refCat = payload.refCat;
      let inmuebleCero = state.inmuebles[0];
      delete inmuebleCero.refInmueble;
      inmuebleCero.inmuebleData = payload;
      let users = [];
      users.push(inmuebleCero.users[0]);
      users[0].data = dataInmueble;
      inmuebleCero.users = users;
      let inmueblesProp = state.propietario.inmuebles
        ? state.propietario.inmuebles
        : [];
      // 1 - users-pre/uid/data-inmuebles/refCat => update inmuebles
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("data-inmuebles")
        .doc(`${refCat}`)
        .set(inmuebleCero)
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Guardado nuevo inmueble en data-inmuebles");
          // 2 - users-pre/uid => update inmuebles
          inmueblesProp.push(refCat);
          dispatch("updateInmuebleUser", inmueblesProp);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Error Creando nuevo inmuble en data-inmubles", error);
        });
    },
    updateInmuebleUser: ({ rootState }, payload) => {
      const uid = rootState.user.uid;
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .update({ inmuebles: payload })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Actualizado inmuebles en perfil de usuario");
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(
            "Error actualizando inmuebles en perfil de usuario",
            error
          );
        });
    },
    setChangeInmuebles: ({ commit }, payload) => {
      commit("setChangeInmuebles", payload);
    },
    deleteUserDataInmueble: ({ rootState, state }, payload) => {
      const uid = rootState.user.uid;
      const refCat = payload.inmueble;
      const user = payload.id;
      const inmueble = state.inmuebles.filter(
        i => i.inmuebleData.refCat === refCat
      )[0];
      if (!inmueble) {
        return;
      }
      const users = inmueble.users.filter(i => i.id != user);
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("data-inmuebles")
        .doc(`${refCat}`)
        .update({ users: users })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Usuario eliminado de data-inmuebles");
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Error eliminando usuario de data-inmuebles", error);
        });
    },
    deleteCoPropietario: ({ rootState, dispatch }, payload) => {
      const uid = rootState.user.uid;
      const id = payload.id;
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("co-propietarios")
        .doc(`${id}`)
        .delete()
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Co-Propietario eliminado", id);
          // Eliminar co-propietario de data-inmuebles
          dispatch("deleteUserDataInmueble", payload);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error("Error eliminado Co-Propietario: ", error);
        });
    },
    setFirmas: ({ rootState, commit }) => {
      const uid = rootState.user.uid;
      if (unsuscribeFirmas) {
        unsuscribeFirmas();
      }
      if (uid) {
        unsuscribeFirmas = dbFS
          .collection("users-pre")
          .doc(`${uid}`)
          .collection("firmas")
          .onSnapshot(
            querySnapshot => {
              let datos = [];
              querySnapshot.forEach(doc => {
                let data = doc.data();
                data.id = doc.id;
                datos.push(data);
              });
              commit("setFirmasMut", datos);
            },
            error => {
              // eslint-disable-next-line
              console.error(error)
            }
          );
      }
    },
    setCoPropietarios: ({ rootState, commit }) => {
      const uid = rootState.user.uid;
      if (unsuscribeCoPropietarios) {
        unsuscribeCoPropietarios();
      }
      if (uid) {
        unsuscribeCoPropietarios = dbFS
          .collection("users-pre")
          .doc(`${uid}`)
          .collection("co-propietarios")
          .onSnapshot(
            querySnapshot => {
              let datos = [];
              querySnapshot.forEach(doc => {
                let data = doc.data();
                data.id = doc.id;
                datos.push(data);
              });
              commit("setCoPropietarios", datos);
            },
            error => {
              // eslint-disable-next-line
              console.error(error)
            }
          );
      }
    },
    setPropietario: ({ rootState, commit, dispatch }) => {
      // const usr = rootState.usuario;
      const uid = rootState.user.uid;
      if (unsuscribeUser) {
        unsuscribeUser();
      }
      if (uid) {
        unsuscribeUser = dbFS
          .collection("users-pre")
          .doc(`${uid}`)
          .onSnapshot(
            doc => {
              let datos = doc.data();
              delete datos.admin;
              commit("setPropietario", datos);
              dispatch("checkInmueblesBD", datos.inmuebles);
              /* if (datos.inmuebles) {
                dispatch("checkInmueblesData", datos.inmuebles);
              } */
              /* if (
                datos.inmuebles &&
                (!datos.inmueblesList || datos.inmueblesList.length < 1)
              ) {
                dispatch("checkInmueblesData", datos.inmuebles);
              } */
            },
            error => {
              // eslint-disable-next-line
              console.error(error)
            }
          );
      }
    },
    saveInmueble: ({ rootState }, payload) => {
      const uid = rootState.user.uid;
      const refCat = payload.inmuebleData.refCat;
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("data-inmuebles")
        .doc(`${refCat}`)
        .set(payload);
    },
    updateInmueble: ({ rootState }, payload) => {
      const uid = rootState.user.uid;
      const refCat = payload.refCat;
      // eslint-disable-next-line no-console
      console.log(`users-pre/${uid}/data-inmuebles/${refCat} : `, payload);
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("data-inmuebles")
        .doc(`${refCat}`)
        .update({ inmuebleData: payload })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Actualizado inmueble");
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Error actualizando data-inmuebles", error);
        });
    },
    checkInmueblesBD: ({ rootState, commit, dispatch }) => {
      const uid = rootState.user.uid;
      // .collection("data-inmuebles")
      if (unsuscribeInmuebles) {
        unsuscribeInmuebles();
      }
      unsuscribeInmuebles = dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("data-inmuebles")
        .onSnapshot(
          querySnapshot => {
            let datos = [];
            querySnapshot.forEach(doc => {
              datos.push(doc.data());
            });
            if (datos.length < 1) {
              // eslint-disable-next-line no-console
              console.log("No hay datos inmuebles");
              dispatch("checkInmueblesData");
            } else {
              // eslint-disable-next-line no-console
              console.log("datos: ", datos);
              commit("setDataInmuebles", datos);
              dispatch("setInmueblesDisponibles");
            }
          },
          error => {
            // eslint-disable-next-line
            console.error(error)
          }
        );
    },
    checkInmueblesData: ({ rootState, state, commit, dispatch }) => {
      // let inmuebles = payload;
      // eslint-disable-next-line no-console
      console.log("Chequeando inmuebles...");
      let inmuebles = state.propietario.inmuebles;
      if (!Array.isArray(inmuebles)) {
        inmuebles = Object.keys(inmuebles);
      }
      if (inmuebles.length < 1) {
        return;
      }
      inmuebles.forEach(element => {
        if (
          !state.propietario.inmueblesList ||
          state.propietario.inmueblesList.length < 1 ||
          state.propietario.inmueblesList.filter(
            i => i.inmuebleData.refCat === element
          ).length < 1
        ) {
          const inmuebleData = functions.httpsCallable("getInmuebleData");
          inmuebleData(element)
            .then(data => {
              let datos = data.data;
              let dataUser = JSON.parse(JSON.stringify(state.propietario));
              delete dataUser.inmuebles;
              delete dataUser.inmueblesList;
              datos.users = [
                {
                  id: rootState.user.uid,
                  data: dataInmueble,
                  userType: "principal"
                }
              ];
              dispatch("saveInmueble", datos);
              datos.users[0].dataUser = dataUser;
              commit("setInmueblesPropietario", datos);
            })
            .catch(error => {
              // eslint-disable-next-line no-console
              console.log(error);
            });
        }
      });
    },
    setInmueblesDisponibles: ({ rootState, state, commit, dispatch }) => {
      const uid = rootState.user.uid;
      const inmuebles = state.inmuebles;
      if (!inmuebles || !inmuebles[0] || !inmuebles[0].listInmuebles) {
        // Pedir a servidor
        // eslint-disable-next-line no-console
        console.log(`Pedir inmuebles al servidor para usuario ${uid}`);
      } else {
        const lista = inmuebles[0].listInmuebles;
        const refsUsadas = inmuebles.map(i => i.inmuebleData.refCat);
        let result = [];
        // result.push(lista);
        lista.forEach(inmueble => {
          const refCat = inmueble.refCat;
          const encuentra = refsUsadas.filter(i => i === refCat)[0];
          if (!encuentra) {
            result.push(inmueble);
          }
        });
        commit("setInmueblesDisponibles", result);
      }
    },
    checkInmueblesDataOld: ({ dispatch }, payload) => {
      let inmuebles = payload;
      if (!Array.isArray(inmuebles)) {
        inmuebles = Object.keys(inmuebles);
      }
      if (inmuebles.length < 1) {
        return;
      }
      let result = [];
      inmuebles.forEach(element => {
        const refCat = element.slice(0, 14);
        if (refCat.length !== 14) {
          return;
        }
        const refInmueble = {
          refCat: refCat,
          num: element.slice(14, 18),
          nonce: element.slice(18, 20)
        };
        dbFB
          .ref("catastro")
          .child(refCat)
          .once("value")
          .then(snapshot => {
            const data = snapshot.val();
            const inmuebleData =
              data.inmuebles && data.inmuebles[refInmueble.num]
                ? data.inmuebles[refInmueble.num]
                : null;
            result.push({
              refInmueble: refInmueble,
              inmuebleData: inmuebleData,
              expte: data.expediente || null
            });
          });
      });
      // commit("setInmueblesPropietario", result);
      dispatch("setInmuExptes", result);
    },
    setInmuExptes: ({ commit }, payload) => {
      let inmuebles = payload;
      if (inmuebles.length < 1) {
        return;
      }
      let result = [];
      inmuebles.forEach(element => {
        const expte = element.expte;
        const basicData = functions.httpsCallable("getExpteBasicData");
        basicData(expte)
          .then(data => {
            result.push({
              refInmueble: element.refInmueble,
              inmuebleData: element.inmuebleData,
              expte: expte,
              customId: data.customId,
              direccion: {
                nombreComunidad: data.nombreComunidad,
                dir: data.direccion,
                localidad: data.localidad,
                provincia: data.provincia,
                ca: data.ca,
                cp: data.cp
              }
            });
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log(error);
          });
        /* dbFB
          .ref("expedientes")
          .child(expte)
          .once("value")
          .then(snapshot => {
            const data = snapshot.val();
            result.push({
              refInmueble: element.refInmueble,
              inmuebleData: element.inmuebleData,
              expte: expte,
              customId: data.customId,
              direccion: {
                nombreComunidad: data.nombreComunidad,
                dir: data.direccion,
                localidad: data.localidad,
                provincia: data.provincia,
                ca: data.ca,
                cp: data.cp
              }
            });
          }); */
      });
      commit("setInmueblesPropietario", result);
    },
    saveDataUser: ({ rootState }, payload) => {
      const uid = rootState.user.uid;
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .set(payload);
    },
    setPropietarioDialog: ({ commit }, payload) => {
      const value = !!payload.value;
      if (payload.dialog === "formProfile") {
        commit("setDialogUsuario", value);
      }
      if (payload.dialog === "formInmueble") {
        commit("setDialogInmueble", value);
      }
      if (payload.dialog === "formProfileInmueble") {
        commit("setDialogProfileInmueble", value);
      }
    },
    newPropietario: ({ rootState, dispatch }, payload) => {
      const uid = rootState.user.uid;
      let nuevoP = modelCoPropietario;
      // nuevoP.dataUser.inmueblesList = [payload];
      nuevoP.dataUser.inmueblesList = [];
      let idProp = dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("co-propietarios")
        .doc();
      // eslint-disable-next-line no-console
      console.log("Generado ID Previo: ", idProp.id);
      nuevoP.id = idProp.id;
      idProp.set(nuevoP).then(() => {
        // eslint-disable-next-line no-console
        console.log("Added document with ID: ", idProp.id);
        const data = {
          inmueble: payload,
          id: idProp.id
        };
        dispatch("addCoPropInmueble", data);
        // commit("setUltimoCoProAgregado", idProp.id);
      });
      /* dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("co-propietarios")
        .add(nuevoP)
        .then(ref => {
          // eslint-disable-next-line no-console
          console.log("Added document with ID: ", ref.id);
          commit("setUltimoCoProAgregado", ref.id);
        }); */
    },
    addCoPropInmueble: ({ rootState, state, commit }, payload) => {
      const uid = rootState.user.uid;
      let coProp = state.coPropietarios.filter(i => i.id === payload.id)[0];
      if (!coProp || !coProp.dataUser.inmueblesList) {
        return;
      }
      let inmueblesList = coProp.dataUser.inmueblesList;
      inmueblesList.push(payload.inmueble);
      // coProp.dataUser.inmueblesList.push(payload.inmueble);
      // Comprueba que exista el inmueble
      const inmueble = state.inmuebles
        ? state.inmuebles.filter(
            i => i.inmuebleData.refCat === payload.inmueble
          )[0]
        : [];
      if (inmueble.length < 1) {
        return;
      }
      // Comprueba que el nuevo usuario no pertenezca ya al inmueble
      let users = inmueble.users;
      const user = users.filter(i => i.id === payload.id);
      if (user.length > 0) {
        return;
      }
      users.push({
        id: payload.id,
        tipo: "secundario",
        data: dataInmueble
      });
      // Guarda en data-inmuebles
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("data-inmuebles")
        .doc(payload.inmueble)
        .update({ users: users })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Actualizado data-inmuebles");
          dbFS
            .collection("users-pre")
            .doc(`${uid}`)
            .collection("co-propietarios")
            .doc(payload.id)
            .update({ "dataUser.inmueblesList": inmueblesList })
            .then(() => {
              // eslint-disable-next-line no-console
              console.log("Actualizado co-propietario");
              commit("setUltimoCoProAgregado", payload.id);
            })
            .catch(error => {
              // eslint-disable-next-line no-console
              console.log("Error actualizando co-propietario", error);
            });
          // .set(coProp);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Error actualizando data-inmuebles", error);
        });
    },
    despropiaCoProp: ({ rootState, state, dispatch }, payload) => {
      const uid = rootState.user.uid;
      let coProp = state.coPropietarios.filter(i => i.id === payload.id)[0];
      if (!coProp || !coProp.dataUser.inmueblesList) {
        return;
      }
      const inmuebles = coProp.dataUser.inmueblesList.filter(
        i => i != payload.inmueble
      );
      coProp.dataUser.inmueblesList = inmuebles;
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("co-propietarios")
        .doc(payload.id)
        .set(coProp);
      // Eliminar co-propietario de data-inmuebles
      dispatch("deleteUserDataInmueble", payload);
    },
    saveDataInmuebleUser: ({ rootState, state }, payload) => {
      const uid = rootState.user.uid;
      const refCat = payload.inmueble;
      const userId = payload.id;
      const inmu = state.inmuebles.filter(
        i => i.inmuebleData.refCat === refCat
      )[0];
      const users = inmu.users;
      let result = [];
      let guardar = false;
      users.forEach(element => {
        let item = element;
        if (
          element.id === userId &&
          JSON.stringify(item.data) != JSON.stringify(payload.data)
        ) {
          guardar = true;
          item.data = payload.data;
        }
        result.push(item);
      });
      if (!guardar) {
        // eslint-disable-next-line no-console
        console.log("Nada que guardar...");
        return;
      }
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("data-inmuebles")
        .doc(payload.inmueble)
        .update({ users: result })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Actualizado data-inmuebles");
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Error actualizando data-inmuebles", error);
        });
    },
    updateCoPropietario: ({ rootState }, payload) => {
      const uid = rootState.user.uid;
      const userId = payload.id;
      let data = payload;
      delete payload.id;
      dbFS
        .collection("users-pre")
        .doc(`${uid}`)
        .collection("co-propietarios")
        .doc(userId)
        .update({ dataUser: data })
        .then(() => {
          // eslint-disable-next-line no-console
          console.log("Actualizado co-propietario");
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log("Error actualizando co-propietario", error);
        });
    },
    saveFirma: ({ commit }, payload) => {
      // eslint-disable-next-line no-console
      console.log("Guardar firma:", payload);
      const save = functions.httpsCallable("updateFirma");
      save(payload)
        .then(data => {
          const datos = data.data;
          // eslint-disable-next-line no-console
          console.log(datos);
          if (datos.success) {
            commit("firmaGuardada", true);
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    resetFirma: ({ commit }) => {
      commit("firmaGuardada", false);
    },
    actDesFirma: ({ rootState, state }, payload) => {
      /**
       * payload = {
       *  id: id del usuario,
       *  isActive: true ó false
       * }
       */
      const uid = rootState.user.uid;
      const userId = payload.id;
      const firma = state.firmas
        ? state.firmas.filter(i => i.id === userId)[0]
        : null;
      // eslint-disable-next-line no-console
      console.log(payload, firma);
      if (firma && firma.isActive != payload.isActive) {
        dbFS
          .collection("users-pre")
          .doc(`${uid}`)
          .collection("firmas")
          .doc(userId)
          .update({ isActive: payload.isActive })
          .then(() => {
            // eslint-disable-next-line no-console
            console.log("Actualizada Firma");
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log("Error actualizando Firma", error);
          });
      } else if (!firma) {
        dbFS
          .collection("users-pre")
          .doc(`${uid}`)
          .collection("firmas")
          .doc(userId)
          .set({ isActive: payload.isActive, firma: null })
          .then(doc => {
            // eslint-disable-next-line no-console
            console.log("Agregada Firma", doc);
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log("Error actualizando Firma", error);
          });
      }
    }
  }
};
